import { useState, useLayoutEffect } from "react";
import type { Location } from "react-router-dom";

export function useExternalHistory(history?: any) {
  const [location, setLocation] = useState<Location | undefined>(
    history?.location,
  );

  useLayoutEffect(() => {
    if (!history) return;

    setLocation(history.location);

    // history v4 (used by react-router v5): listener receives (location, action)
    return history.listen((location: Location) => {
      setLocation(location);
    });
  }, [history]);

  return location;
}
